import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject, Subscription } from 'rxjs';
import { ControltowerService } from 'src/app/services/dashboards/controltower.service';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { PropertiesTowers } from 'src/app/services/dashboards/propertiesTower.service';
import { takeUntil } from 'rxjs/operators';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'neoris-save-device',
  templateUrl: './save-device.component.html',
  styleUrl: './save-device.component.css'
})
export class SaveDeviceComponent implements OnInit {
 
  saveDeviceForm:UntypedFormGroup = new UntypedFormGroup({})
  displayedColumns: string[] = [
    'Id', 'Code', 'Name', 'TypeDevice', 'TypeId', 'Brand', 'ClientId', 
    'IpAddress', 'DeviceConfigurationUrl', 'Username', 'Password', 'Model', 
    'SerialNr', 'IsEnabled'
  ];

  clients: any[] = [] 
  private onLanChange:Subscription
  languaje:string=''
  arrayDeviceTypes: any[] = []
  arrayLocations:any[]=[]
  requestDeleteDevice:any = {} 
  private onClick:Subscription
  private unsubscribe$: Subject<any> = new Subject<any>();
  @ViewChild('fileInput') fileInput: ElementRef | undefined;
  selectedFile: File | null = null;
  public arrayImages: any[] = []  

  constructor(private fb: FormBuilder,
    private controltowerservice:ControltowerService,
    private translate:TranslateService,
    private routers:Router,
    private _snackBar:MatSnackBar,
    public dialog: MatDialog,
    private route: Router,
    private propertiesService:PropertiesTowers,
    private http: HttpClient,
       private sanitizer: DomSanitizer,
  ) { 
    this.saveDeviceForm = this.fb.group({
      Id: [0],
      Code: ['', Validators.required],
      Name: ['', Validators.required],
      TypeDevice: [''],
      TypeId: ['', Validators.required],
      Brand: ['', Validators.required],
      ClientId: ['', Validators.required],
      IpAddress: ['', Validators.required],
      IsEnabled: ['', Validators.required],
      DeviceConfigurationUrl: ['', Validators.required],
      Username: ['', Validators.required],
      Password: ['', Validators.required],
      Model: ['', Validators.required],
      SerialNr: ['', Validators.required],
      LocationId:['', Validators.required],
      image:new UntypedFormControl(null),
      isUpdateOrNewImage:[false],
      imageArray:new UntypedFormControl(null),
    });
  }

  async ngOnInit(): Promise<void> {
    let siteId = localStorage.getItem('site');
    console.log('siteId',siteId)

    this.onLanChange = this.translate.onLangChange.subscribe(s => {
      console.log("idioma",s.lang)
      this.languaje = s.lang != undefined ? s.lang : "en";
      console.log('entre para llamar a atributte')
      let successDeviceManagement = this.getGenericAtrributeValue(this.languaje)      
    })

    this.onClick = this.propertiesService.clickBtnAddDevice.pipe(takeUntil(this.unsubscribe$)).subscribe(async (value) => {
      console.log('valor recibido de click en el form',value)
      if(value){
        await this.bindingData()
      }
    })

    if(this.languaje == undefined || this.languaje == ''){
      console.log('entre para llamar a atributte')
      let successDeviceManagement = this.getGenericAtrributeValue('en')
      }


     await this.getClientsByUser()

     await this.getLocations(siteId)

     
  }

  async onSubmit(){
    console.log(this.saveDeviceForm.value)


    console.log("estatus del formulario",this.saveDeviceForm.valid)
    if(this.saveDeviceForm.valid){
      console.log('el formulario si es valido')
    let exito = await this.SaveSourceDevice(this.saveDeviceForm.value)

    if(exito){
      console.log('entre en uno')
      this.openSnackBar(this.translate.instant('ALERT_SUCCESS'),"OK")
      this.routers.navigate(["/catDevices"]);
 
    }
    else{
      console.log('entre en dos')
      this.openSnackBar(this.translate.instant('ALERT_FAILED'),"FAILED")
     
    }
    }



  }



  bindingData(){
    const selectedDevice: any = JSON.parse(localStorage.getItem('rowSelectCatDevice'))

    console.log("rowSelectCatDevice rows------------------->", selectedDevice)


    this.saveDeviceForm.controls['Id'].setValue(selectedDevice.id)
    this.saveDeviceForm.controls['Code'].setValue(selectedDevice.code)
    this.saveDeviceForm.controls['Name'].setValue(selectedDevice.name)
    this.saveDeviceForm.controls['TypeId'].setValue(selectedDevice.typeId)
    this.saveDeviceForm.controls['Brand'].setValue(selectedDevice.brand)
    this.saveDeviceForm.controls['ClientId'].setValue(selectedDevice.clientId)
    this.saveDeviceForm.controls['IpAddress'].setValue(selectedDevice.ipAddress)
    this.saveDeviceForm.controls['DeviceConfigurationUrl'].setValue(selectedDevice.deviceConfigurationUrl)
    this.saveDeviceForm.controls['Username'].setValue(selectedDevice.username)
    this.saveDeviceForm.controls['Password'].setValue(selectedDevice.password)
    this.saveDeviceForm.controls['Model'].setValue(selectedDevice.model)
    this.saveDeviceForm.controls['SerialNr'].setValue(selectedDevice.serialNr)
    this.saveDeviceForm.controls['LocationId'].setValue(selectedDevice.locationId)
    this.saveDeviceForm.controls['IsEnabled'].setValue(selectedDevice.isEnabled)

    let objectURL = `data:image/jpeg;base64,` + selectedDevice.imageArray;
    let image = this.sanitizer.bypassSecurityTrustUrl(objectURL);
    this.arrayImages.push({imagefile:image})   

    

    //this.saveDeviceForm.value
  }

  

  openSnackBar(message: string, action: string) {
    if(action == 'OK'){
    this._snackBar.open(message, action, {
      duration: 5000,
      panelClass: ['blue-snackbar']
    });
  }
  else{
    this._snackBar.open(message, action, {
      duration: 5000,
      panelClass: ['blue-snackbar-false']
    });
  }
  }


  private async getClientsByUser(): Promise<boolean> {
    
    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.getClientsByUserName().subscribe(
        {
          next: (arrayclients: any={}) => {

            console.log("array de clientes------>", arrayclients)
            this.clients = arrayclients
           
       
            resolve(true);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });
  }


  private async getLocations(site:string): Promise<boolean> {
    
    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.getLocationsBySite(site).subscribe(
        {
          next: (arraylocations: any={}) => {

            console.log("array de locations------>", arraylocations)
            this.arrayLocations = arraylocations
           
       
            resolve(true);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });
  }


  private async getGenericAtrributeValue(localCode:string): Promise<boolean> {
   

    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.getAttributeValue(localCode).subscribe(
        {
          next: (attribute: any={}) => {
            
            console.log('attribute',attribute)

            for(let i=0;i<= attribute.attributeTypes.length -1;i++){
              if(attribute.attributeTypes[i].id == 5){
                this.arrayDeviceTypes = attribute.attributeTypes[i].attributeValues

              }
             

            }
           
            
            resolve(true);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });
  }


  private async SaveSourceDevice(request:any): Promise<any> {
    
    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.SaveSourceDevice(request).subscribe(
        {
          next: (report: any) => {
            console.log('respondio el save reporte--->:',report);
                                  
            resolve(report);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });

  }

  private async DeleteSourceDevice(request:any): Promise<any> {
    
    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.DeleteSourceDevice(request).subscribe(
        {
          next: (report: any) => {
            console.log('respondio el save reporte--->:',report);
                                  
            resolve(report);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });

  }


  public cellClick(obj: any) {
    localStorage.setItem('rowSelectCatDevice',JSON.stringify(obj))
    this.route.navigate(['/savedevice'])
  }



  async openConfirmDialog(){
    const selectedDevice: any = JSON.parse(localStorage.getItem('rowSelectCatDevice'))
    console.log('openConfirmDialog')
    const dialogRef = this.dialog.open(ConfirmDialogComponent);

     dialogRef.afterClosed().subscribe(async result => {
      if (result) {

      this.requestDeleteDevice.id = selectedDevice.id
       let exito =  await this.DeleteSourceDevice(this.requestDeleteDevice)
        console.log('Action confirmed',exito);
        if(exito){
          console.log('Action confirmed');
          
          this.routers.navigate(["/catDevices"]);
          this.openSnackBar(this.translate.instant('ALERT_SUCCESS'),"OK")
        }
        else{
          this.openSnackBar(this.translate.instant('ALERT_FAILED'),"FAILED")
     
        }


      } else {
        // Action was cancelled
        console.log('Action cancelled');
      }
    });
  }




  /*onFileSelected(event: any) {
    this.selectedFile = event.target.files[0];
    console.log(this.selectedFile); 

    const byteArray = new Uint8Array([this.selectedFile.size]);

    this.saveDeviceForm.patchValue({
      image: byteArray
    });

    console.log('valor del formulario',this.saveDeviceForm.value)

  }*/

    onFileSelected(event: any) {
      this.selectedFile = event.target.files[0];
      console.log(this.selectedFile);
    
      const reader = new FileReader();
      reader.onload = () => {
        const byteArray = new Uint8Array(reader.result as ArrayBuffer);
    
        // Convertir el array de bytes a una cadena Base64
        const base64String = this.arrayBufferToBase64(byteArray);
    
        this.saveDeviceForm.patchValue({
          image: base64String,
          isUpdateOrNewImage:true
        });
    
        console.log('valor del formulario', this.saveDeviceForm.value);
      };
    
      reader.readAsArrayBuffer(this.selectedFile);
    }
    
    arrayBufferToBase64(buffer: Uint8Array): string {
      let binary = '';
      const len = buffer.byteLength;
      for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(buffer[i]);
      }
      return btoa(binary);
    }

  onUpload() {
    event.preventDefault(); 
    if (this.selectedFile) {
      const formData = new FormData();
      formData.append('image', this.selectedFile, this.selectedFile.name);

      this.http.post('YOUR_API_ENDPOINT', formData)
        .subscribe(response => {
          console.log(response);
        });
    }
  }

  openFileInput() {
    event.preventDefault(); 
    this.fileInput?.nativeElement.click();
  }

}
